import { render, staticRenderFns } from "./SplitManager.template.vue?vue&type=template&id=c42c400e&scoped=true&"
var script = {}
import style0 from "./SplitManager.template.vue?vue&type=style&index=0&id=c42c400e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42c400e",
  null
  
)

export default component.exports